import { Control, Controller } from "react-hook-form";
import { useState } from "react";

import { Calendar } from "components/Calendar/Calendar";
import { NamedCounter } from "components/NamedCounter/NamedCounter";
import { Row } from "components/Row/Row";
import { Paragraph } from "components/Paragraph/Paragraph";
import { Checkbox } from "components/Checkbox/Checkbox";
import { AppSelect } from "components/Select/Select";
import { NamedInput } from "components/NamedInput/NamedInput";

import styles from "../../styles.module.css";

import { ClientInfoMarketing } from "./index";

type Props = {
  control: Control<ClientInfoMarketing>;
};

export function AddFieldsRow({ control }: Props) {
  const [visibleCalendar, setVisibleCalendar] = useState<boolean>(false);

  return (
    <Row className={`${styles.row} ${styles.add_fields_row}`}>
      <div
        className="flex flex-1 gap-6 items-center bg-inherit"
        style={{ paddingBlock: "10px" }}
      >
        <Paragraph
          style={{ width: "22px", display: "flex", minWidth: "22px" }}
          className={styles.table_body_column}
        >
          {" "}
        </Paragraph>
        <Controller
          name="name"
          control={control}
          render={({ field }) => (
            <NamedInput
              {...field}
              style={{
                width: "132px",
                display: "flex",
                minWidth: "132px",
                border: 0,
                outline: 0,
              }}
              placeholder="Название"
            />
          )}
        />
        <Controller
          name="date"
          control={control}
          render={({ field }) => (
            <Calendar
              onShow={() => setVisibleCalendar(!visibleCalendar)}
              setVisibleCalendar={setVisibleCalendar}
              visibleCalendar={visibleCalendar}
              onChange={(e) => {
                field.onChange(e);
              }}
              value={field.value ? new Date(field.value) : null}
              inputClassname={styles.calendar_input}
              placeholder="Дата"
            />
          )}
        />
        <Controller
          name="bonus"
          control={control}
          render={({ field }) => (
            <NamedInput
              {...field}
              style={{
                width: "55px",
                display: "flex",
                minWidth: "55px",
                border: 0,
                outline: 0,
              }}
              placeholder="Бонус"
            />
          )}
        />
        <Paragraph
          style={{ width: "150px", display: "flex", minWidth: "150px" }}
          className={styles.table_body_column}
        >
          <Controller
            name="plusbonus"
            control={control}
            render={({ field }) => <NamedCounter {...field} title="" />}
          />
        </Paragraph>
        <Controller
          name="pluspercent"
          control={control}
          render={({ field }) => (
            <NamedCounter
              {...field}
              title=""
              style={{
                width: "70px",
                display: "flex",
                minWidth: "70px",
                border: 0,
                outline: 0,
              }}
            />
          )}
        />
        <Paragraph
          style={{
            width: "240px",
            minWidth: "240px",
            display: "flex",
            alignItems: "center",
            columnGap: "6px",
          }}
          className={styles.table_body_column}
        >
          <Controller
            name="radiusminus"
            control={control}
            render={({ field }) => (
              <NamedCounter {...field} title="до: " titleWidth={23} />
            )}
          />
          <Controller
            name="radiusplus"
            control={control}
            render={({ field }) => (
              <NamedCounter {...field} title="после: " titleWidth={43} />
            )}
          />
        </Paragraph>
        <Paragraph
          style={{ width: "52px", display: "flex", minWidth: "52px" }}
          className={styles.table_body_column}
        >
          <Controller
            name="burnday"
            control={control}
            render={({ field }) => (
              <Checkbox
                checked={!!field.value}
                onChange={() => field.onChange(!field.value)}
              />
            )}
          />
        </Paragraph>
        <Paragraph
          style={{ width: "130px", display: "flex", minWidth: "130px" }}
          className={styles.table_body_column}
        >
          <Controller
            name="useonce"
            control={control}
            render={({ field }) => (
              <Checkbox
                checked={!!field.value}
                onChange={() => field.onChange(!field.value)}
              />
            )}
          />
        </Paragraph>
        <Paragraph
          style={{ width: "60px", display: "flex", minWidth: "60px" }}
          className={styles.table_body_column}
        >
          <Controller
            name="domessage"
            control={control}
            render={({ field }) => (
              <Checkbox
                checked={!!field.value}
                onChange={() => field.onChange(!field.value)}
              />
            )}
          />
        </Paragraph>
        <Paragraph
          style={{ width: "166px", display: "flex", minWidth: "166px" }}
          className={styles.table_body_column}
        >
          <Controller
            name="smstextid"
            control={control}
            render={({ field }) => (
              <AppSelect
                {...field}
                options={[]}
                value={undefined}
                placeholder="Шаблон СМС"
                className={styles.sms_select}
              />
            )}
          />
        </Paragraph>
        <Paragraph
          style={{
            width: "145px",
            display: "flex",
            alignItems: "center",
            columnGap: "6px",
            minWidth: "115px",
          }}
          className={styles.table_body_column}
        >
          <span>за</span>
          <Controller
            name="rememberday"
            control={control}
            render={({ field }) => <NamedCounter {...field} title="" />}
          />
          <span>дней</span>
        </Paragraph>
      </div>
    </Row>
  );
}
